import React from 'react';
import type { AppState } from '../types';
import { PageShell, glassLight, EmptyState, Badge, T } from '../ui';
export function Mapa({
  state
}: {
  state: AppState;
}) {
  return <PageShell title="Mapa" sub="Vista geográfica de todas las sucursales" data-id="element-643">
      {state.sucs.length === 0 ? <EmptyState title="Sin sucursales que mostrar" hint="Agrega sucursales para verlas ubicadas en el mapa." icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" data-id="element-645">
              <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" data-id="element-646" />
              <line x1="9" y1="3" x2="9" y2="18" data-id="element-647" />
              <line x1="15" y1="6" x2="15" y2="21" data-id="element-648" />
            </svg>} data-id="element-644" /> : <div style={{
      ...glassLight,
      minHeight: 360,
      padding: 22,
      position: 'relative',
      overflow: 'hidden'
    }} data-id="element-649">
          {/* grid */}
          <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'linear-gradient(rgba(255,255,255,.035) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.035) 1px,transparent 1px)',
        backgroundSize: '42px 42px'
      }} data-id="element-650" />
          {/* accent aurora */}
          <div style={{
        position: 'absolute',
        top: -60,
        right: -40,
        width: 240,
        height: 240,
        borderRadius: '50%',
        background: `radial-gradient(circle, ${T.accent}1c 0%, transparent 70%)`,
        pointerEvents: 'none'
      }} data-id="element-651" />

          {/* legend */}
          <div style={{
        position: 'absolute',
        top: 16,
        left: 18,
        zIndex: 2
      }} data-id="element-652">
            <Badge label={`${state.sucs.length} sucursales`} color={T.accent} soft={T.accentSoft} data-id="element-653" />
          </div>

          {state.sucs.map((s, i) => <div key={s.id} style={{
        position: 'absolute',
        left: `${18 + i * 26 % 64}%`,
        top: `${30 + i % 3 * 22}%`,
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        animation: 'fadeUp .4s ease both',
        animationDelay: `${i * 0.06}s`
      }} data-id="element-654">
              <span style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: T.accent,
          border: `3px solid ${T.accentSoft}`,
          boxShadow: `0 0 14px ${T.accent}`
        }} data-id="element-655" />

              <span style={{
          fontSize: 13,
          fontWeight: 600,
          color: T.text,
          background: 'rgba(10,14,38,0.8)',
          border: `1px solid ${T.border}`,
          padding: '6px 11px',
          borderRadius: T.rSm,
          backdropFilter: 'blur(8px)'
        }} data-id="element-656">
                {s.nombre}
              </span>
            </div>)}
        </div>}
    </PageShell>;
}